import { render, staticRenderFns } from "./larvicide.vue?vue&type=template&id=4160712a&"
import script from "./larvicide.vue?vue&type=script&lang=js&"
export * from "./larvicide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports